export const transformPropIfString = (obj: object, clean: (value: string) => string) => {
  for (const key of Object.keys(obj)) {
    const value = obj[key]
    if (typeof value === 'string') {
      obj[key] = clean(value)
    }
  }
}

export const cleanPropIfString = (obj: object) =>
  // eslint-disable-next-line no-control-regex
  transformPropIfString(obj, (value: string) => value.replaceAll(/[\x00-\x1F\x7F]/gi, '').trim())
